import React from 'react';

import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import { MEDIUM_TYPO } from 'theme/typography';

export const FilterSelectButton = ({ endIcon, children, onClick }) => (
  <Button
    onClick={onClick}
    disableElevation
    disableRipple
    sx={{
      height: '32px',
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      padding: 1,
      paddingRight: 3,
      paddingLeft: 3,
      backgroundColor: 'background.white',
      border: '1px solid',
      borderColor: 'background.secondary',
      borderRadius: '100px',
      fontFamily: MEDIUM_TYPO,
      textTransform: 'none',
      color: 'text.dark',
      '&.Mui-disabled': {
        color: 'text.primary',
        opacity: '0.5',
      },
      '&:hover:not(disabled)': {
        color: 'text.dark',
        borderColor: 'background.secondary',
      },
      '&:focus:not(disabled)': {
        color: 'text.dark',
      },
      '&:active:not(disabled)': {
        color: 'text.dark',
        borderColor: 'background.secondary',
      },
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    }}
  >
    {children}
    <span style={{ flexShrink: 0 }}>{endIcon}</span>
  </Button>
);

FilterSelectButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  endIcon: PropTypes.node,
};
